import { Component } from '@angular/core';
import { Header } from '../header/header';
import { InfoPanel } from '../info-panel/info-panel';
import { Map } from '../map/map';

@Component({
  selector: 'app-dashboard',
  imports: [Header, Map, InfoPanel],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss'
})
export class Dashboard {}
